
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[articleHandle]",
      function () {
        return require("private-next-pages/articles/[articleHandle].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[articleHandle]"])
      });
    }
  